import type { Engagement } from '../types/content'

export const engagements: Engagement[] = [
  {
    kicker: 'Platform',
    title: 'Waydev',
    description:
      'An AI-native engineering intelligence platform. It maps AI velocity across the SDLC on top of DORA, SPACE, and DX, and turns developer tool data into board-ready evidence of adoption, impact, and return.',
    points: [
      'AI adoption by team, repository, and tool',
      'Impact on cycle time, review depth, and rework',
      'Cost and return modelling against real spend',
      'Connects GitHub, GitLab, Bitbucket, Azure DevOps, Jira, Copilot, Cursor, Claude Code',
      'SOC 2, DPA, and SCC coverage for regulated buyers',
    ],
    linkLabel: 'See the platform',
    href: 'https://waydev.co',
    external: true,
  },
  {
    kicker: 'Advisory',
    title: 'SDLC and AI transformation consulting',
    description:
      'Direct engagement, no delivery team behind it. I come in when the question is strategic rather than operational, and when the answer has to survive contact with a CFO or an audit committee.',
    points: [
      'Two-week AI ROI diagnostic on your existing data',
      'Engineering operating model and org design review',
      'Metrics program design that engineers do not resent',
      'Tooling consolidation, build versus buy, vendor selection',
      'Technical due diligence for investors and acquirers',
    ],
    linkLabel: 'Discuss an engagement',
    href: '#contact',
  },
]
